import React from 'react'
import styles from './index.module.less'

interface DetailBreadcrumbProps {
  children?: string
}

export default function DetailBreadcrumb({ children }: DetailBreadcrumbProps) {
  return (
    <div className={styles.title} title={children}>
      {children}
    </div>
  )
}
